"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localStoragePlugin = void 0;
var hasLocalStorage = typeof localStorage !== "undefined";

var localStoragePlugin = function localStoragePlugin(storageKey) {
  var leadEvents = function leadEvents(lead) {
    return {
      onUpdate: function onUpdate() {
        if (hasLocalStorage) {
          localStorage.setItem(storageKey, JSON.stringify(lead));
        }
      }
    };
  };

  leadEvents.clearCache = function () {
    if (hasLocalStorage) {
      localStorage.removeItem(storageKey);
    }
  };

  leadEvents.onLoad = function (initialState) {
    if (initialState || !hasLocalStorage) return initialState;
    var val = localStorage.getItem(storageKey);
    if (!val) return;

    try {
      return JSON.parse(val);
    } catch (err) {
      localStorage.removeItem(storageKey);
      return;
    }
  };

  return leadEvents;
};

exports.localStoragePlugin = localStoragePlugin;